//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { resolvePublicRoute } from '~/utils/cms-routes.cjs';

export default {
  name: 'base-breadcrumbs',
  computed: {
    ...mapGetters('cms', { publicNavigation: 'navigation' }),
    crumbs () {
      const publicRoute = this.isCabinet && resolvePublicRoute(this.$route.path);
      if (publicRoute) {
        return this.publicNavigation
          .filter(page => page.id === 'home' || page.path === publicRoute.path ||
            publicRoute.path.startsWith(page.path + '/'))
          .sort((left, right) => left.path.length - right.path.length)
          .map(page => ({
            path: page.path,
            title: page.id === 'home' ? this.$t('index.title') : page.title,
          }));
      }
      const { fullPath } = this.$route;
      const params = fullPath.startsWith('/')
        ? fullPath.substring(1).split('/')
        : fullPath.split('/');
      const crumbs = [{
        title: this.$t('index.title'),
        path: '/',
      }];
      let path = '';
      params.forEach((param) => {
        path = `${path}/${param}`;
        const match = this.$router.match(path);
        if (match.meta.name && this.isParams(match.params)) {
          // eslint-disable-next-line vue/max-len
          const nameKey = `${match.meta.titleLocaleKey || match.meta.name.replace(/-/g, '.')}.title`;
          const title = `
          ${this.$t(nameKey)} 
          ${!match.meta.withoutId && this.isId(match.params) ? `№${match.params.id}` : ''}
          `;
          crumbs.push({
            title: title,
            ...match,
          });
        }
      });

      return crumbs;
    },
    crumbsWithoutCurrent () {
      return this.crumbs.slice(0, -1);
    },
  },
  methods: {
    isParams (params) {
      if (!Object.keys(params).length) return true;
      return typeof params.id !== 'undefined' && params.id !== 'edit';
    },
    isId (params) {
      if (!Object.keys(params).length) return false;
      return !!params.id;
    },
  },
};
